// extracted by mini-css-extract-plugin
export default {"fullWidth":"Jo-z","image":"Ko-z","lazyLoadPicture":"Lo-z","lazyLoadSpinner":"Mo-z","lazyLoadSpin":"No-z","lazyLoadImage":"Oo-z","hasStyledAspectRatio":"Po-z"};